<div fxLayout="column" fxLayoutGap="0.5rem">
    <mat-divider *ngIf="data.divider !== false"></mat-divider>
    <div *ngIf="data && data.title" class="fs-3 title" [innerHTML]="data.title | safeHtml" [style.font-size]="data?.titleFontSize"></div>
    <div class="subtitle-group">
        <div *ngIf="data && data.subtitle" class="fs-6 subtitle" [ngClass]="data.ngClass" [innerHTML]="data.subtitle | safeHtml"></div>
        <mat-icon *ngIf="data && data.subtitle && data.show_info" class="fs-6 icon info-title" (click)="infoClick()">info_outlined</mat-icon>
    </div>
</div>